// @flow
import Immutable from "seamless-immutable";
import createReducer from "common/reducerBase";
import { doListsSelection, doListsMultipleSelection } from "tabs/common/reducerMethods";
import DropboxRecord, { getNewList } from "../data/DropboxRecord";
import consts from "../data/consts";
import { types as ats } from "../actions";

const CTXS = consts.CONTEXTS;

export default {
	dropbox: createReducer(DropboxRecord(), {

		[ats.SET_AUTH_INFO]: (state: Object, { payload }) => state.set("token", payload.token),

		[ats.SET_FILES_RETRIEVE_START]: (state: Object, { payload }) => state.set("currentContext", payload.context)
			.setIn(["lists", payload.context, "inProgress"], true),

		[ats.SET_FILES_RETRIEVE_SUCCESS]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...state.lists[payload.context],
			inProgress: false,
			items: payload.items,
			metadata: payload.metadata,
			cursor: payload.cursor,
			hasMore: payload.hasMore,
		}),

		[ats.SET_FILE_SELECTION]: doListsSelection,

		[ats.SET_MULTI_FILE_SELECTION]: doListsMultipleSelection,

		[ats.CLEAR_FILES_FOR_CONTEXT]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...getNewList(),
			inProgress: state.lists[payload.context].inProgress,
		}),

		[ats.CLEAR_IMAGE_SELECTION]: (state: Object, { payload }) => state.setIn(["lists", payload.context, "selected"], []),

		[ats.SET_ACCOUNT_INFO_SUCCESS]: (state: Object, { payload }) => state.set("account", payload.account),

		[ats.SET_USER_LOGOUT_SUCCESS]: (state: Object) => state.replace(DropboxRecord()),

		[ats.SET_SEARCH_TERM]: (state: Object, { payload }) => state.set("searchTerm", payload.term),

		[ats.SET_THUMBNAILS]: (state: Object, { payload }) => state.updateIn(["lists", payload.context, "items"], (items) => {
			items = items.asMutable();
			payload.thumbs.forEach((t, i) => {
				if (items[i] && items[i].thumbnail !== t) {
					items[i] = {
						...items[i],
						thumbnail: t,
					};
				}
			});

			return items;
		}),

		[ats.CLEAR_ALL_SELECTION]: (state: Immutable) => state.merge({
			lists: {
				[CTXS.FOLDER]: { selected: [] },
				[CTXS.RECENT]: { selected: [] },
				[CTXS.SEARCH]: { selected: [] },
			},
		}, { deep: true }),
	}),
};
